(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["approach-tabs"] && !Shopify.designMode) return;
  try {
    
(function() {
  var section = document.querySelector('.tabs-section');
  if (!section) return;
  var bar    = section.querySelector('.tabs-bar');
  var btns   = section.querySelectorAll('.tab-btn');
  var panels = section.querySelectorAll('.tab-panel');
  var kicks  = section.querySelectorAll('.rail-kicker__text');

  btns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var idx = parseInt(btn.dataset.tab, 10);

      btns.forEach(function(b) {
        b.classList.toggle('is-active', b === btn);
        b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
      });
      panels.forEach(function(p, i) {
        p.classList.toggle('is-active', i === idx);
      });

      if (bar) bar.classList.add('is-switching');
      kicks.forEach(function(k) { k.classList.remove('is-active'); });
      setTimeout(function() {
        kicks.forEach(function(k, i) { k.classList.toggle('is-active', i === idx); });
        if (bar) bar.classList.remove('is-switching');
      }, 170);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
(function () {
  var root, itemsEl, totalEl, countEl;

  function money(c) {
    try {
      return (c / 100).toLocaleString(undefined, {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
      });
    } catch (e) { return '$' + (c / 100).toFixed(2); }
  }

  function render(cart) {
    if (!itemsEl) return;
    if (!cart.items || cart.items.length === 0) {
      itemsEl.innerHTML = '<p class="tcd__dempty">Your cart is empty.</p>';
    } else {
      itemsEl.innerHTML = cart.items.map(function (it) {
        var img = it.image ? '<img src="' + it.image + '" alt="">' : '';
        var variant = it.product_has_only_default_variant ? '' : '<div class="tcd__li-v">' + it.variant_title + '</div>';
        return '<div class="tcd__li">' +
          '<div class="tcd__li-img">' + img + '</div>' +
          '<div class="tcd__li-b">' +
            '<h4 class="tcd__li-t">' + it.product_title + '</h4>' + variant +
            '<div class="tcd__li-v">Qty ' + it.quantity + '</div>' +
            '<div class="tcd__li-p">' + money(it.final_line_price) + '</div>' +
          '</div>' +
          '<button class="tcd__li-x" data-tcd-remove="' + it.key + '" aria-label="Remove">&times;</button>' +
        '</div>';
      }).join('');
    }
    if (totalEl) totalEl.textContent = money(cart.total_price);
    if (countEl) countEl.textContent = 'Subtotal (' + cart.item_count + (cart.item_count === 1 ? ' item)' : ' items)');
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
  }

  function refresh() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () {});
  }

  function open() { if (root) { root.classList.add('is-open'); root.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; refresh(); } }
  function close() { if (root) { root.classList.remove('is-open'); root.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; } }

  function addVariant(id, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
    }).then(function () { return refresh(); });
  }

  document.addEventListener('DOMContentLoaded', function () {
    root    = document.getElementById('tcd');
    itemsEl = document.getElementById('tcdItems');
    totalEl = document.getElementById('tcdTotal');
    countEl = document.getElementById('tcdCount');
    if (!root) return;

    var closeBtn = document.getElementById('tcdClose');
    var scrim    = document.getElementById('tcdScrim');
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (scrim)    scrim.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) close();
    });

    document.addEventListener('click', function (e) {
      var add = e.target.closest('[data-tcd-add]');
      if (add) {
        e.preventDefault();
        var label = add.textContent;
        add.disabled = true; add.textContent = 'Adding...';
        addVariant(add.getAttribute('data-tcd-add'), 1).then(function () {
          add.disabled = false; add.textContent = label; open();
        });
        return;
      }

      var rm = e.target.closest('[data-tcd-remove]');
      if (rm) {
        e.preventDefault();
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: rm.getAttribute('data-tcd-remove'), quantity: 0 })
        }).then(refresh);
        return;
      }

      var opener = e.target.closest('[data-cart-drawer-open]');
      if (opener) { e.preventDefault(); open(); return; }

      var ritual = e.target.closest('#tlpAtc');
      if (ritual) {
        e.preventDefault();
        var sel = document.querySelector('#tlp .plan.sel');
        var vid = (sel && sel.getAttribute('data-variant')) || ritual.getAttribute('data-variant');
        if (vid) { addVariant(vid, 1); } else { open(); }
      }
    });

    refresh();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.product-card form').forEach(function(form) {
  form.addEventListener('submit', function(e) {
    e.preventDefault();
    var btn = form.querySelector('.card-cta');
    var id = form.querySelector('[name="id"]').value;
    btn.textContent = '...';
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      btn.textContent = 'Added!';
      return fetch('/cart.js');
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function(el) {
        el.textContent = cart.item_count;
      });
      setTimeout(function() {
        btn.textContent = btn.closest('article').querySelector('.card-name') ? 'Add to Cart' : 'Add to Cart';
        btn.disabled = false;
      }, 1500);
    })
    .catch(function() {
      btn.textContent = 'Add to Cart';
      btn.disabled = false;
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(data) {
      document.querySelectorAll('[data-cart-count]').forEach(function(el) {
        el.textContent = data.item_count;
      });
    })
    .catch(function() {});

  var drawer   = document.getElementById('navDrawer');
  var overlay  = document.getElementById('navOverlay');
  var openBtn  = document.querySelector('.menu-btn');
  var closeBtn = document.getElementById('navDrawerClose');

  function openDrawer() {
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    openBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    closeBtn.focus();
  }
  function closeDrawer() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    openBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    openBtn.focus();
  }

  if (openBtn)  openBtn.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay)  overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.t-cart__row').forEach(function (row) {
    var input = row.querySelector('[data-qty]');
    var dec   = row.querySelector('[data-dec]');
    var inc   = row.querySelector('[data-inc]');
    if (!input) return;

    if (dec) {
      dec.addEventListener('click', function (e) {
        var current = parseInt(input.value, 10) || 0;
        if (current > 1) {
          e.preventDefault();
          input.value = current - 1;
          if (input.form.requestSubmit) { input.form.requestSubmit(); } else { input.form.submit(); }
        }
      });
    }
    if (inc) {
      inc.addEventListener('click', function () {
        input.value = (parseInt(input.value, 10) || 0) + 1;
      });
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var main = document.getElementById('tPdpMain');
  document.querySelectorAll('.t-pdp__thumb').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (main) main.src = btn.getAttribute('data-full');
      document.querySelectorAll('.t-pdp__thumb').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
    });
  });

  var qty = document.getElementById('tPdpQty');
  document.querySelectorAll('.t-pdp__qty-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var step = parseInt(btn.getAttribute('data-step'), 10);
      var next = (parseInt(qty.value, 10) || 1) + step;
      qty.value = next < 1 ? 1 : next;
    });
  });

  var dataEl = document.getElementById('tPdpVariants');
  if (!dataEl) return;
  var variants = JSON.parse(dataEl.textContent);
  var selects  = Array.prototype.slice.call(document.querySelectorAll('.t-pdp__select'));
  var idInput  = document.getElementById('tPdpVariantId');
  var priceEl  = document.getElementById('tPdpPrice');
  var addBtn   = document.getElementById('tPdpAdd');
  var addText  = document.getElementById('tPdpAddText');

  function money(cents) {
    return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: window.Shopify && Shopify.currency ? Shopify.currency.active : 'USD' });
  }

  function update() {
    var chosen = selects.map(function (s) { return s.value; });
    var match = variants.find(function (variant) {
      return chosen.every(function (val, i) { return variant.options[i] === val; });
    });
    if (!match) return;
    idInput.value = match.id;
    if (priceEl) {
      var html = '<span class="t-pdp__price-now">' + money(match.price) + '</span>';
      if (match.compare_at_price && match.compare_at_price > match.price) {
        html += '<s class="t-pdp__price-was">' + money(match.compare_at_price) + '</s>';
      }
      priceEl.innerHTML = html;
    }
    if (addBtn) {
      addBtn.disabled = !match.available;
      if (!match.available) { addText.textContent = 'Sold out'; }
      else if (addText.textContent === 'Sold out') { addText.textContent = 'Add to cart'; }
    }
  }

  selects.forEach(function (s) { s.addEventListener('change', update); });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
(function() {
  var sections = document.querySelectorAll('.testimonials-section');
  sections.forEach(function(section) {
    var track = section.querySelector('.t-track');
    var prev = section.querySelector('[id^="tPrev"]');
    var next = section.querySelector('[id^="tNext"]');
    if (!track || !prev || !next) return;
    var idx = 0;
    function cardWidth() {
      var card = track.querySelector('.t-card');
      if (!card) return 0;
      var gap = parseFloat(getComputedStyle(track).columnGap || '22');
      return card.getBoundingClientRect().width + gap;
    }
    function visibleCount() {
      return Math.max(1, Math.round(track.parentElement.clientWidth / cardWidth()));
    }
    function maxIdx() {
      return Math.max(0, track.children.length - visibleCount());
    }
    function update() {
      idx = Math.max(0, Math.min(idx, maxIdx()));
      track.style.transform = 'translateX(' + (-idx * cardWidth()) + 'px)';
      prev.disabled = idx <= 0;
      next.disabled = idx >= maxIdx();
    }
    prev.addEventListener('click', function() { idx -= 1; update(); });
    next.addEventListener('click', function() { idx += 1; update(); });
    window.addEventListener('resize', update);
    update();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
